module.exports = __webpack_public_path__ + "static/media/chevron_down_white.8ef444b4.svg";